import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import Login from './auth/login/Login';
import Publisher from './pages/publisher/Publisher';
import UserAgent from './pages/userAgent/UserAgent';
import LandingPage from './pages/landingPage/LandingPage';
import AgentCreationPublisher from './pages/publisher/agentCreationPublisher/AgentCreationPublisher';
import UseCase from './pages/apps/useCase/UseCase';
import Leaderboard from './pages/leaderboard/Leaderboard';
import { InitializeGA } from './shared/googleAnalytics/GoogleAnalytics';
import { useEffect } from 'react';
import Admin from './Admin/Admin';
import ByoAgentGuide from './pages/publisher/byoAgentGuide/ByoAgentGuide';

function App() {
  useEffect(() => {
    InitializeGA();
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<LandingPage />} />
        <Route path="/publisher" element={<Publisher />} />
        <Route path="/agent_marketplace" element={<UserAgent />} />
        <Route path="/solutions" element={<UseCase />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/AgentCreationGuidelinePublisher" element={<AgentCreationPublisher />} />
        <Route path="/agent-publishing-journey" element={<Publisher />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/ByoAgentGuide" element={<ByoAgentGuide />} />
      </Routes>
    </Router>
  );
}

export default App;
